import { sendToMixpanel } from '..';
import type { Option } from '../../components/search-autocomplete/types';

export interface SelectSearchSuggestionParams {
  item: Pick<Option, 'category' | 'label' | 'value'>;
  position: number;
  textTyped: string;
  totalSuggestions?: number;
}

const trackSelectSearchSuggestion = ({
  item,
  position,
  textTyped,
  totalSuggestions,
}: SelectSearchSuggestionParams): void => {
  sendToMixpanel('Select Search Suggestion', {
    siteSection: 'Agents',
    suggestionCategory: item.category,
    suggestionPosition: position,
    suggestionTextTyped: textTyped,
    suggestionLabel: item.label,
    suggestionValue: item.value,
    ...(totalSuggestions !== undefined && {
      suggestionSelectionCount: totalSuggestions,
    }),
  });
};

export default trackSelectSearchSuggestion;
